import { removeFromFormArrayAction } from '../../actions/schemaActions';

const removeFromFormArray = (index, component) => {
  component.props.dispatch(
    removeFromFormArrayAction(component.props.id, index)
  );
};

export default removeFromFormArray;
